module.exports = __webpack_public_path__ + "img/learnModel-Pic2.ef337b76.png";